<template>
  <footer>
    <div class="footer-wrapper">
      <!-- <div class="linkBox">
        <ul>
          <li v-for="(item, index) in listData" :key="index" @click="onShow(index)"
            :class="{ active: categoryIndex == index }" :style="{ cursor: 'pointer' }">{{ item.title }}</li>
        </ul>
        <div class="links" :class="{ on: comtentIndex == 0 }">
          <a href="http://www.inzonegroup.cn/">银座集团股份有限公司</a>
          <a href="http://www.lshzy.com.cn/">鲁商健康产业发展股份有限公司</a>
          <a href="http://www.sdwenlv.com/">山东文旅集团</a>
          <a href="http://www.fruida.com.cn/Index.html">山东福瑞达医药集团有限公司</a>
          <a href="http://www.yzhotels.com/">山东银座旅游集团有限公司</a>
          <a href="http://www.etone.com.cn/">山东易通发展集团有限公司</a>
          <a href="http://www.yinzuojiaju.com/">山东银座家居有限公司</a>
          <a href="http://www.inzone-auto.com/">山东银座汽车有限公司</a>
          <a href="http://www.yinzuokids.com/">山东银座英才幼儿园</a>
          <a href="http://www.lsxcjt.com/">鲁商乡村发展集团有限公司</a>
          <a href="http://www.sict.edu.cn/">山东商业职业技术学院</a>
          <a href="http://www.qchm.edu.cn/">青岛酒店管理职业技术学院</a>
          <a href="http://www.sdcc.edu.cn/">山东省城市服务技师学院</a>
          <a href="http://www.qlmu.edu.cn/">齐鲁医药学院</a>
          <a href="http://www.sdaps.cn/">山东省药学科学院</a>
          <a href="http://www.specc.com.cn/">山东省医药工业设计院</a>
          <a href="http://www.yinzuo100.com">银座网</a>
          <a href="http://www.kzdd.cn/?Index.html">康妆大道</a>
          <a href="http://www.sdnews.com.cn">鲁网</a>
        </div>
        <div class="links" :class="{ on: comtentIndex == 1 }">
          <a href="http://www.lushang.com.cn/">鲁商集团</a>
          <a href="http://www.sdsteel.cc/">山东钢铁集团</a>
          <a href="http://www.sd-gold.com/">山东黄金集团</a>
          <a href="http://www.hualuholdings.com/">华鲁集团</a>
          <a href="https://www.luxin.cn/">鲁信集团</a>
          <a href="http://www.sda.cn/">山东航空集团</a>
          <a href="http://www.ykjt.com.cn/">兖矿集团</a>
          <a href="http://www.sdhsg.com/">山东高速集团</a>
          <a href="https://www.jnairport.com/">山东机场集团</a>
          <a href="http://www.sdnxs.com/Site/Home/CN/">山东省农信社联社</a>
          <a href="http://www.qljfjt.com/">齐鲁交通发展集团</a>
          <a href="http://sdtdfz.com/">山东土地发展集团</a>
          <a href="http://www.sdgzkg.com/">山东国投</a>
          <a href="http://www.sdfztz.com/">山东发展投资集团</a>
          <a href="http://www.sdtz.net.cn/col/index.html">山东财金集团</a>
          <a href="http://www.snjt.com/index.htm">山东能源集团</a>
          <a href="http://www.sdnydb.com/">山东农担公司</a>
          <a href="http://www.sdcig.com/ch/">山东交通工业集团</a>
          <a href="http://www.shig.com.cn/">山东重工集团</a>
          <a href="http://www.sdsalt.cn/">山东盐业集团</a>
          <a href="http://www.szdhjt.com/">东华集团</a>
          <a href="http://www.shanghaiqilu.com/">上海齐鲁集团</a>
          <a href="http://www.sdcqjy.com/">山东产权交易中心</a>
          <a href="http://www.sdghjj.com/">山东国惠投资</a>
          <a href="http://www.sdtj.sd.cn/">山东特检集团</a>
          <a href="http://www.tsdkjt.com/">山东泰山地勘集团</a>
          <a href="http://www.sdkjjt.cn/">山东山科控股集团</a>
          <a href="http://www.sdlljt.com.cn/index_pc.jsp">鲁粮集团</a>
          <a href="http://www.sdsf.com.cn/">水发集团</a>
          <a href="http://www.sdseed.com.cn/">山东种业集团</a>
          <a href="https://www.sdmg.com.cn/">山东海洋集团</a>
          <a href="http://www.gtzlw.com/index.mvc">国泰租赁</a>
          <a href="http://www.zts.com.cn/">中泰证券</a>
          <a href="http://www.sdzdb.com/">山东再担保集团</a>
          <a href="https://www.taishanpic.com/">泰山保险</a>
          <a href="https://www.qlotc.com/">齐鲁股权交易中心</a>
          <a href="https://www.ergo-life.cn/">德华安顾人寿</a>
        </div>
        <div class="links" :class="{ on: comtentIndex == 2 }">
          <a href="http://www.shandong.gov.cn/">山东省政府</a>
          <a href="http://gzw.shandong.gov.cn/">山东省人民政府国有资产监督管理委员会</a>
          <a href="http://www.sdqts.gov.cn/">山东省质量技术监督局</a>
          <a href="http://www.sdta.gov.cn/">山东省文化和旅游厅</a>
          <a href="http://www.shandong.gov.cn">山东省人民政府办公厅</a>
          <a href="http://www.sdfgw.gov.cn/">山东省发展和改革委员会</a>
          <a href="http://gxt.shandong.gov.cn/col/col15869/index.html">山东省工业和信息化厅</a>
          <a href="http://www.sdedu.gov.cn">山东省教育厅</a>
          <a href="http://www.sdstc.gov.cn">山东省科学技术厅</a>
          <a href="http://www.sdmz.gov.cn">山东省民政厅</a>
          <a href="http://www.sdcz.gov.cn">山东省财政厅</a>
          <a href="http://www.sdhrss.gov.cn/">山东省人力和社会保障厅</a>
          <a href="http://www.sddlr.gov.cn">山东省国土资源厅</a>
          <a href="http://www.sdjs.gov.cn/">山东省住房和城乡建设厅</a>
          <a title="山东省煤田地质局" href="http://www.mtkc.com/">山东省煤田地质局</a>
        </div>
      </div> -->
      <div class="comBox">
        <p :style="{ color: '#ffffff', fontSize: '14px', opacity: '0.5' }" class="comAddress">公司地址：山东省济南市历下区鲁商国奥城5号楼 丨
          <span class="tel">电话：400-865-6118</span>
        </p>
        <p :style="{ color: '#898787', fontSize: '12px', opacity: '0.5', paddingTop: '5px' }" class="comInfo">
          鲁ICP备19034510号-1 丨
          Copyright © 2019-现在 丨 鲁商通版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        { title: "兄弟单位" },
        { title: "省属国企" },
        { title: "政府部门" },
      ],
      categoryIndex: 0,
      comtentIndex: 0,
    };
  },
  methods: {
    onShow(index) {
      this.categoryIndex = index;
      this.comtentIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: relative;
  background: #222222;
  color: rgb(137, 135, 135);
  padding-top: 50px;
  padding-bottom: 50px;
}

.linkBox {
  padding-bottom: 20px;
}

.footer-wrapper {
  // color: black;
  text-align: center;
  padding: 10px 0;

  ul {
    list-style: none;
    display: flex;
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-around;
  }
}

.active {
  color: #ffffff;
}

.links {
  width: 1200px;
  overflow: hidden;
  margin-top: 10px;
  display: none;
  margin: 0 auto;
  padding: 28px 0;

  a {
    color: #898787;
    text-decoration: none;
    margin-left: 20px;
    font-size: 14px;
    display: inline-block;
    padding-bottom: 7px;
  }
}

.links.on {
  display: block;
}

.on {
  display: block;
}

@media (max-width: 768px) {
  .footer-wrapper ul {
    width: 90%;
    padding: 0;
    justify-content: space-between;
  }

  .links {
    width: 100%;
    text-align: left;
  }

  .comAddress {
    font-size: 13px !important;
  }

  .comBox {
    width: 90%;
    margin-left: 5%;

    .tel {
      display: block;
    }
  }
}
</style>